module.exports = __webpack_public_path__ + "assets/img/kv-ec9b6fff.jpg";